module.exports = __webpack_public_path__ + "static/img/aisc-kRFGc_PO.dc7b9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/aisc-kRFGc_PO.png
// module id = jFI4
// module chunks = 16